export default __webpack_public_path__ + "static/llanfyrnach-2097ab3aedbafb605a7dd8b48d067577.jpg";